import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({})
export default class SvMoneyInput extends Vue {
    @Prop({})
    value?: number;
    numberFormatter = new Intl.NumberFormat('en-US');
    mounted() {
        this.valueChange();
    }

    @Watch("value")
    valueChange() {
        const input = (this.$el as HTMLInputElement);
        input.value = (this.value != null && this.value.toString() != "") ? this.numberFormatter.format(this.value) : "";
    }

    input(e: KeyboardEvent) {
        const input = e.target as HTMLInputElement;
        let sanitized = input.value.replace(/\,/g, '');
        if (!isNaN(Number(sanitized))) {
            if (sanitized) {
                const num = parseInt(sanitized, 10);
                input.value = this.numberFormatter.format(num);
                sanitized = num.toString();
            }
            this.$emit("input", sanitized);
        }
    }
}
